export function normalizeHost(host) {
    return "requestUpdate" in host ? host : host();
}
